import React from "react";
import "./notificationCenter.scss";

import { NovuInbox } from "../notifications/notification-center";

const NotificationCenter = () => {
  return (
    <div className="notification-center" id="notification-scroll">
      <NovuInbox />
    </div>
  );
};

export default NotificationCenter;
